// @flow

import styled, { css } from 'styled-components';

const sizes = {
  md: '.9em',
  lg: '1.2em',
};

export const Button = styled.button`
  border: none;
  background: none;
  cursor: not-allowed;
  outline: none;

  text-align: center;
  text-decoration: none;
  text-transform: ${props => props.theme.button.textTransform || 'none'};

  font-weight: bold;

  position: relative;
  display: inline-block;
  padding: 0.7em 1em;

  ::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    opacity: 0;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1);
  }

  transition: filter 200ms cubic-bezier(0, 0, 0.2, 1);

  ${({ disabled = false }) => !disabled && css`
    cursor: pointer;
    :hover, :focus {
      filter: brightness(115%);
      ::before {
        opacity: .1;
      }
    }
    &:active {
      box-shadow: none;
    }
  `}

  ${({ size = 'md', theme, rounded = false }) => css`
    font-size: ${sizes[size]};

    border-radius: ${rounded || theme.button.rounded ? `calc(${sizes[size]} * 2)` : `calc(${theme.radius} * 0.8)`};
    ::before {
      border-radius: ${rounded || theme.button.rounded ? `calc(${sizes[size]} * 2)` : `calc(${theme.radius} * 0.8)`};
    }
  `}

  ${({ flat = false }) => !flat && css`
    box-shadow: 0 1px 5px rgba(0,0,0,.2),
                0 2px 2px rgba(0,0,0,.14),
                0  3px 1px -2px rgba(0,0,0,.12);
  `}

  ${({ outline = false, theme, type = 'default' }) => css`
    background-color: ${type === 'default' || outline ? 'transparent' : theme.colors.new_primary[600]};
    color: ${type === 'default' ? theme.colors.black : outline ? theme.colors.new_primary[600] : 'white'};
  `}

  ${({ type = 'default', theme }) => css`
    border: 1px solid ${type === 'default' ? theme.colors.black : theme.colors.new_primary[600]};

    ::before {
      background-color: ${type === 'default' ? 'black' : theme.colors[type](46)};
    }
  `}

  ${props => props.block && css`
    display: block;
    width: 100%;
    max-width: 100%;
  `}

`;
